//import React, { Component, useRef } from 'react';
import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from "@material-ui/core/Button";
import MaterialTable from 'material-table';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import AttachFileIcon from "@material-ui/icons/AttachFile";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import 'moment-timezone';
import moment from 'moment'

export class EntryIntervention extends Component {

    constructor(props) {
        super(props);
        this.state = {
            usersNameCreate: "",
            loading: true,
            notAuthorized: true,

            isFetching: false,

            userType: -1,

            listRevisionFileDetailsOptions: [],

            listRevisionFileDetailsSelected: "",
            filenameRS: "",
            files: [],
        }

        this.refUserUpdate = React.createRef();
    }

    componentDidMount() {
        this.loadUsers();
        this.getUserType();
        this.getListRevisionFileDetails();
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    handleChange = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    loadUsers = async () => {

        await fetch(global.variables.API_USEROPERATIONS_LOADALLUSERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({
                        loading: false,
                        notAuthorized: true
                    });
                } else {
                    this.setState({
                        users: result.listofusers,
                        loading: false,
                        notAuthorized: false
                    });
                }
            });
    };

    getListRevisionFileDetails = async () => {

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_FILEUPLOADDOWNLOAD_LISTREVISIONFILEDETAILS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    //toast.success("Success!", {
                    //    position: toast.POSITION.BOTTOM_RIGHT
                    //});

                    for (var i = 0; i < result.listofrevisiondetails.length; i++) {
                        //console.log(result.listofrevisiondetails[i].revisionFiles);
                        //console.log(JSON.parse(result.listofrevisiondetails[i].revisionFiles).RS);
                        var RSid = JSON.parse(result.listofrevisiondetails[i].revisionFiles).RS;

                        if (RSid > 0) {

                        } else {
                            console.log(result.listofrevisiondetails[i].MissionNumber);
                            console.log(result.listofrevisiondetails[i].ProjectTitle);
                            console.log(result.listofrevisiondetails[i].ProjectNumber);
                            console.log(result.listofrevisiondetails[i].revisionIteration);

                            var v = this.state.listRevisionFileDetailsOptions;
                            v.push({
                                TypeId: result.listofrevisiondetails[i].idRevisions,
                                TypeName: result.listofrevisiondetails[i].idRevisions
                                    + " " + result.listofrevisiondetails[i].MissionNumber
                                    + " " + result.listofrevisiondetails[i].ProjectTitle
                                    + " " + result.listofrevisiondetails[i].ProjectNumber
                                    + " Iteration: " + result.listofrevisiondetails[i].revisionIteration
                            });

                            this.setState({ listRevisionFileDetailsOptions: v });

                            console.log("listRevisionFileDetailsOptions: " + this.state.listRevisionFileDetailsOptions);
                        }

                    }

                } else {
                    //toast.error("Failed!", {
                    //    position: toast.POSITION.BOTTOM_RIGHT
                    //});
                }

            });

        await this.setState({ isFetching: false });
    };

    uploadRSFile = async () => {

        await this.setState({ isFetching: true });

        console.log("listRevisionFileDetailsSelected: " + this.state.listRevisionFileDetailsSelected);

        var formData = new FormData();

        if (this.state.files && this.state.files.length > 0) {
            var filesarray = this.state.files;
            for (var i = 0; i < filesarray.length; i++) {
                //console.log("Appending files " + filesarray[i].filename);
                formData.append(filesarray[i].filename, filesarray[i].fileblob);
            }
        }

        var postData = this.state;
        Object.keys(postData).forEach((key, value) => {
            if (key !== "files") {
                formData.append(key, postData[key]);
            }
        });

        await fetch(global.variables.API_FILEUPLOADDOWNLOAD_UPLOADRSFILEANDUPDATEREVISIONID, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                //Accept: "application/json",
                //"Content-Type": "application/json"
            },
            //body: JSON.stringify(this.state)
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });

                    //for (var i = 0; i < result.listofrevisiondetails.length; i++) {
                    //    //console.log(result.listofrevisiondetails[i].revisionFiles);
                    //    //console.log(JSON.parse(result.listofrevisiondetails[i].revisionFiles).RS);
                    //    var RSid = JSON.parse(result.listofrevisiondetails[i].revisionFiles).RS;

                    //    if (RSid > 0) {

                    //    } else {
                    //        console.log(result.listofrevisiondetails[i].MissionNumber);
                    //        console.log(result.listofrevisiondetails[i].ProjectTitle);
                    //        console.log(result.listofrevisiondetails[i].ProjectNumber);
                    //        console.log(result.listofrevisiondetails[i].revisionIteration);

                    //        var v = this.state.listRevisionFileDetailsOptions;
                    //        v.push({
                    //            TypeId: result.listofrevisiondetails[i].idRevisions,
                    //            TypeName: result.listofrevisiondetails[i].idRevisions
                    //                + " " + result.listofrevisiondetails[i].MissionNumber
                    //                + " " + result.listofrevisiondetails[i].ProjectTitle
                    //                + " " + result.listofrevisiondetails[i].ProjectNumber
                    //                + " Iteration: " + result.listofrevisiondetails[i].revisionIteration
                    //        });

                    //        this.setState({ listRevisionFileDetailsOptions: v });

                    //        console.log("listRevisionFileDetailsOptions: " + this.state.listRevisionFileDetailsOptions);
                    //    }

                    //}

                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

            });

        await this.setState({ isFetching: false });
    };

    handleFileInputChange = event => {
        var filesvar = this.state.files;
        filesvar.push({
            filename: event.target.name,
            fileblob: event.target.files[0]
        });
        this.setState({ files: filesvar });

        console.log("event.target.name " + event.target.name);

        if (event.target.name === "fileRS") {
            this.setState({ filenameRS: event.target.files[0].name });
        }
    };

    returnArrayElement = (array, element) => {

        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {

        //var userPermissionOptions = [
        //    { TypeId: 1, TypeName: "Administrator" },
        //    { TypeId: 2, TypeName: "Mission Coordinator" },
        //    //{ TypeId: 3, TypeName: "ROMIS User (Expert, QC, QA)" },
        //    { TypeId: 3, TypeName: "Experts (ROM, QC, QA)" },
        //    { TypeId: 4, TypeName: "Key Partners (EUD, CFCU, DEUA)" }
        //];

        //var userStatusOptions = [
        //    { TypeId: 0, TypeName: "Active" },
        //    { TypeId: 1, TypeName: "Inactive" }
        //];

        const {
            usersNameCreate,
            isFetching,
            userType,
            listRevisionFileDetailsSelected,
            listRevisionFileDetailsOptions,
            onChangeRS,
            filenameRS,
        } = this.state;

        if (this.state.loading) {
            return (
                <Grid container spacing={3} >
                    <Grid item xs={12} className="mt-2" style={{ textAlign: "center", display: this.state.loading ? "block" : "none" }}>
                        <CircularProgress /> Loading...
                    </Grid>
                </Grid>
            );
        } else if (this.state.notAuthorized) {
            return (
                <p>You are not authorized</p>
            );
        } else {
            return (
                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Revision File Details" className='romis-card-header' />
                            <CardContent>
                                {
                                    //<TextField
                                    //    label="Name Entry : *"
                                    //    placeholder="Name"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChangeTitleCase}
                                    //    value={usersNameCreate}
                                    //    name="usersNameCreate"
                                    ///>
                                }

                                <Autocomplete
                                    options={listRevisionFileDetailsOptions}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => { this.handleSelectChange(e, v, "listRevisionFileDetailsSelected") }}
                                    value={this.returnArrayElement(listRevisionFileDetailsOptions, listRevisionFileDetailsSelected)}
                                    renderInput={params => (
                                        <TextField {...params} label="Select Cycle" margin="normal" fullWidth />
                                    )}
                                    disabled={false}
                                />

                                {
                                    //<Grid item xs={12} height="100%">
                                    //    <Button
                                    //        variant="contained"
                                    //        color="primary"
                                    //        onClick={this.getListRevisionFileDetails}
                                    //        fullWidth
                                    //    >
                                    //        Get List of Revision File Details
                                    //    </Button>
                                    //</Grid>
                                }

                                <Grid item xs={12} height="100%">

                                    <input
                                        style={{ display: "none" }}
                                        id="contained-button-file-rs"
                                        name="fileRS"
                                        multiple
                                        type="file"
                                        onChange={this.handleFileInputChange.bind(this)}
                                    />
                                    <label htmlFor="contained-button-file-rs" style={{ width: "100%" }}>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="large"
                                            component="span"
                                            fullWidth
                                            startIcon={<AttachFileIcon />}
                                            disabled={false}
                                        >
                                            RS UPLOAD
                                        </Button>
                                    </label>

                                    <Typography
                                        variant="caption"
                                        component="h2"
                                        style={{
                                            display: "none" ? filenameRS === "" : "block"
                                        }}
                                    >
                                        {filenameRS}
                                    </Typography>

                                </Grid>

                                <Grid item xs={12} height="100%">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.uploadRSFile}
                                        fullWidth
                                    >
                                        Upload Selected
                                    </Button>
                                </Grid>

                            </CardContent>
                        </Card>
                    </Grid>

                </Grid>
            );
        }
    }
}





// WEBPACK FOOTER //
// ./src/pages/EntryIntervention.js